"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Collapse_1 = __importDefault(require("@mui/material/Collapse"));
const FormHelperText_1 = __importDefault(require("@mui/material/FormHelperText"));
const common_buoy_icons_1 = require("@buoyhealth/common.buoy-icons");
const styled_components_1 = __importDefault(require("styled-components"));
const StyledText = (0, styled_components_1.default)(FormHelperText_1.default) `
  &.MuiFormHelperText-root {
    font-size: 0.875rem;
    display: flex;
    align-items: center;
    line-height: normal;
    margin-left: 7px;
  }
`;
const Container = styled_components_1.default.div `
  display: flex;
  margin-top: 0.5rem;
  align-items: flex-start;

  .BuoyIcon-Container {
    margin-top: 3px;
    height: 16px;
  }
`;
const ErrorText = ({ show, message }) => ((0, jsx_runtime_1.jsx)(Collapse_1.default, { in: show, children: (0, jsx_runtime_1.jsxs)(Container, { children: [(0, jsx_runtime_1.jsx)(common_buoy_icons_1.AlertIcon, { size: 14 }), (0, jsx_runtime_1.jsx)(StyledText, { error: true, children: message })] }) }));
exports.default = ErrorText;
//# sourceMappingURL=index.js.map